;(function() {
  'use strict'

  Controller.$inject = ["$q", "$state", "StateFactory", "channelService", "profileService", "QuotaPlan", "quotaCellsService", "quotaCellStateService", "surveyServiceNext"];
  angular.module('app.core').controller('PublicChannelStats', Controller)

  /* @ngInject */
  function Controller(
    $q,
    $state,
    StateFactory,
    channelService,
    profileService,
    QuotaPlan,
    quotaCellsService,
    quotaCellStateService,
    surveyServiceNext
  ) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.channelId = $state.params.channelId
      ctrl.sharedBy = $state.params.sharedBy
      ctrl.state = new StateFactory(['loading', 'ready', 'error'])
      ctrl.state.loading()
      loadChannel()
        .then(loadProfile)
        .then(loadSurvey)
        .then(function() {
          refreshLegacyTagQuotas()
          refreshQuotaPlanSummary()

          ctrl.state.ready()
        })
        .catch(function(error) {
          console.error(error)
          ctrl.state.error()
        })
    }

    function loadChannel() {
      return channelService
        .get(ctrl.channelId)
        .then(function(channel) {
          ctrl.channel = channel
        })
        .catch(function(err) {
          return $q.reject(err)
        })
    }

    function loadProfile() {
      return profileService.get(ctrl.channel.ownerId).then(function(profile) {
        ctrl.profile = profile
      })
    }

    function loadSurvey() {
      return surveyServiceNext
        .get(ctrl.channel.survey.id)
        .then(function(survey) {
          ctrl.survey = survey
        })
    }

    function refreshLegacyTagQuotas() {
      ctrl.tags = []

      if (ctrl.channel.getTagQuotaTotal() !== 0) {
        ctrl.tags = ctrl.channel.tags.slice()
      } else if (!hasQuotaPlans() && ctrl.survey.tagQuotaSettings.enabled) {
        ctrl.tags = ctrl.survey.getTagQuotas()
      }

      ctrl.hasLegacyTagQuotas = _.some(ctrl.tags, function(tag) {
        return tag.quota > 0
      })
    }

    function hasQuotaPlans() {
      return _.isArray(ctrl.survey.quotaPlans)
    }

    function refreshQuotaPlanSummary() {
      ctrl.quotaPlan = QuotaPlan.findByChannelId(
        ctrl.survey.quotaPlans,
        ctrl.channel.id
      )

      ctrl.quotaSummary = ctrl.quotaPlan
        ? buildPlanSummary(ctrl.quotaPlan)
        : null

      ctrl.quotaPlanPaused = !!ctrl.quotaPlan && !ctrl.quotaPlan.enabled
    }

    function buildPlanSummary(plan) {
      var questions = ctrl.survey.getQuestions()

      var counts = ctrl.survey.tagCounts || {}

      var target = 0
      var achieved = 0
      var setCount = 0
      var blankCount = 0

      plan.getQuotas().forEach(function(quota) {
        quotaCellsService.getCells(quota, questions).forEach(function(cell) {
          achieved += counts[cell.counterName] || 0

          var cellTarget = plan.getTarget(quota.id, cell.cellKey)

          if (_.isNumber(cellTarget)) {
            target += cellTarget
            setCount++
          } else {
            blankCount++
          }
        })
      })

      var barTarget = setCount ? target : null

      return {
        target: setCount ? target : null,
        hasBlank: blankCount > 0,
        achieved: achieved,
        state: quotaCellStateService
          .getState(barTarget, achieved)
          .toLowerCase(),
        fillPercent: quotaCellStateService.getFillPercent(barTarget, achieved),
        hasBar: quotaCellStateService.hasBar(barTarget),
      }
    }
  }
})()
